import React, { Component } from 'react';
import { Col, Row } from 'antd';
import { SubTitle, Text } from 'common-components/typography';
import CommonUtils from 'utilities/common-utils';

class ViewQuotationManualQuoteView extends Component<any, any> {
  render() {
    const { quotation } = this.props;
    return (
      <div className={'p-medium bg-secondary'}>
        <div className={'rounded-big bg-blue-action-lightest'}>
          <Row
            className={'pv-small bordered-bottom bordered-left bordered-right border-standard-gray'}
            type={'flex'}
            align={'middle'}
          >
            <Col span={1} />
            <Col span={8} className={'pl-medium'}>
              <Text weight={'bold'}>Total</Text>
            </Col>
            <Col span={4} className={'text-align-right'}>
              <SubTitle>Quote Amount</SubTitle>
              <Text weight={'bold'}>{CommonUtils.formatPrice(Number(quotation.quoteAmount))}</Text>
            </Col>
            <Col span={4} className={'text-align-right'}>
              <SubTitle>Amount spent</SubTitle>
              <Text weight={'bold'}>{CommonUtils.formatPrice(Number(quotation.spentAmount))}</Text>
            </Col>
            <Col span={4} className={'text-align-right'}>
              <SubTitle>Balance</SubTitle>
              <Text weight={'bold'}>
                {CommonUtils.formatPrice(Number(quotation.quoteAmount) - Number(quotation.spentAmount))}
              </Text>
            </Col>
            <Col span={3} />
          </Row>
        </div>
      </div>
    );
  }
}

export default ViewQuotationManualQuoteView;
